export const invoiceTypeColorMap = new Map([
  [1, '#ff4d4f'],
  [0, '#1890ff'],
])
export const invoiceTypeTextMap = new Map([
  [1, '专票'],
  [0, '普票'],
])
export const invoiceNewTypeTextMap = new Map([
  [1, '专用发票'],
  [0, '普通发票'],
])
export const invoiceListStorageKey = 'userInvoiceStorageKey'
export const addressListStorageKey = 'useraddressStorageKey'
export const invoiceEditItemStorageKey = 'invoiceEditItemStorageKey'
export const addressEditItemStorageKey = 'addressEditItemStorageKey'
export const confirmUseInvoiceStorageKey = 'confirmUseInvoiceStorageKey'
export const selectInoviceStorageKey = 'selectInoviceStorageKey'
export const cacheFromStorageKey = 'cacheFromStorageKey'
